import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from 'grid-styled';

const ContentWrapper = styled(Box)`
  max-width: calc(100vw - 300px);
  /* //overflow-y: auto; */
  position: relative;
  /* align-self: center; */
  width: 100%;

  @media only screen and (max-width: ${props => props.theme.mq.large}) {
    max-width: 100%;
  }

  @media only screen and (min-width: ${props => props.theme.mq.xLarge}) {
    max-width: 1150px;
  }

  ${props =>
    props.verticalcenter &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
    `};
`;

class Content extends React.Component {
  render() {
    const { verticalcenter } = this.props;
    return (
      <ContentWrapper
        verticalcenter={verticalcenter ? 1 : 0}
        width={1 / 1}
        flex="1 1 auto"
        pt={20}
        pl={20}
        pr={20}
        pb={20}
        is="div"
      >
        {this.props.children}
      </ContentWrapper>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/BasePage/Content.js